/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of reporting a no-show
 * @export
 * @interface NoShowReportResponse
 */
export interface NoShowReportResponse {
    /**
     * 
     * @type {boolean}
     * @memberof NoShowReportResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof NoShowReportResponse
     */
    matchStatus: string;
    /**
     * 
     * @type {string}
     * @memberof NoShowReportResponse
     */
    winnerId?: string;
    /**
     * 
     * @type {string}
     * @memberof NoShowReportResponse
     */
    message: string;
}

/**
 * Check if a given object implements the NoShowReportResponse interface.
 */
export function instanceOfNoShowReportResponse(value: object): value is NoShowReportResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('matchStatus' in value) || value['matchStatus'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function NoShowReportResponseFromJSON(json: any): NoShowReportResponse {
    return NoShowReportResponseFromJSONTyped(json, false);
}

export function NoShowReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoShowReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'matchStatus': json['matchStatus'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
        'message': json['message'],
    };
}

export function NoShowReportResponseToJSON(json: any): NoShowReportResponse {
    return NoShowReportResponseToJSONTyped(json, false);
}

export function NoShowReportResponseToJSONTyped(value?: NoShowReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'matchStatus': value['matchStatus'],
        'winnerId': value['winnerId'],
        'message': value['message'],
    };
}

